import { createAsyncThunk } from "@reduxjs/toolkit";
import { INonWorkingDaysCreatePayload, INonWorkingDaysPayload } from "../types";
import { setNonWorkingDays } from "./nonWorkingDaysSlice";
import request from "service";
import dayjs from "dayjs";

const GetNonWorkingDays = createAsyncThunk(
    "nonWorkingDays/getNonWorkingDays",
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.get("/academic-calendar-days");

            let filteredData = response.data.filter((item: INonWorkingDaysPayload) => item.kind === "non_working");

            dispatch(setNonWorkingDays(filteredData));
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

const CreateNonWorkingDays = createAsyncThunk(
    "nonWorkingDays/createNonWorkingDays",
    async (data: INonWorkingDaysCreatePayload, { rejectWithValue }) => {
        try {
            const response = await request.post("/academic-calendar-days", data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

const UpdateNonWorkingDays = createAsyncThunk(
    "nonWorkingDays/updateNonWorkingDays",
    async (
        academicWeekData: {
            academic_year_id: number;
            kind: string;
            formatedDates: string[];
            year_to_id?: number;
        },
        { rejectWithValue }
    ) => {
        try {
            const inferredData = {
                academic_year_id: academicWeekData.academic_year_id,
                kind: academicWeekData.kind,
                dates: academicWeekData.formatedDates.map(date => dayjs(date).format("YYYY-MM-DD")),
                year_to_id: academicWeekData.year_to_id,
            };
            const response = await request.post(`/academic-calendar-days`, inferredData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

const DeleteNonWorkingDays = createAsyncThunk(
    "nonWorkingDays/deleteNonWorkingDays",
    async (id: number, { rejectWithValue }) => {
        try {
            const response = await request.delete(`/academic-calendar-days/${id}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export { GetNonWorkingDays, CreateNonWorkingDays, UpdateNonWorkingDays, DeleteNonWorkingDays };
